// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';
import { AdditionalDeviceTypeComponent } from './additionalDeviceTypeComponent';

/**
 * Serializes Vital Sign Types from database.
 * @see #/components/schemas/AdditionalDeviceType - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface AdditionalDeviceType {
    readonly code: string;
    /**
     * The display name for the additional device
     *
     */
    display_name?: string;
    /**
     * The type for the additional device  * `integer` - Integer * `decimal` - Dezimal * `text` - Text * `boolean` - Boolean * `group` - Gruppe
     *
     */
    type?: AdditionalDeviceType.TypeEnum | null;
    /**
     * The unit for the additional device (required for integer and decimal types)
     *
     */
    unit?: string;
    /**
     * The visibility for the additional device
     *
     */
    is_visible?: boolean;
    readonly components: Array<AdditionalDeviceTypeComponent>;
    /**
     * Whether additional device is automated.
     *
     */
    readonly is_automated: boolean;
    /**
     * Whether the additional device is always visible.
     *
     */
    is_always_visible?: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for AdditionalDeviceType
 */
export namespace AdditionalDeviceType {
    export type TypeEnum = 'integer' | 'decimal' | 'text' | 'boolean' | 'group' | 'null';
    export const TypeEnum = {
        Integer: 'integer' as TypeEnum,
        Decimal: 'decimal' as TypeEnum,
        Text: 'text' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Group: 'group' as TypeEnum,
        Null: 'null' as TypeEnum,
    };

    /**
     * AdditionalDeviceType Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        readonly code: string;
        /**
         * The display name for the additional device
         * @type string (`dataFormat` is missing)
         */
        displayName?: string;
        /**
         * The type for the additional device  * `integer` - Integer * `decimal` - Dezimal * `text` - Text * `boolean` - Boolean * `group` - Gruppe
         * @type string (`dataFormat` is missing)
         */
        type?: AdditionalDeviceType.TypeEnum | null;
        /**
         * The unit for the additional device (required for integer and decimal types)
         * @type string (`dataFormat` is missing)
         */
        unit?: string;
        /**
         * The visibility for the additional device
         * @type boolean (`dataFormat` is missing)
         */
        isVisible?: boolean;
        @Type(() => AdditionalDeviceTypeComponent.Model)
        readonly components: Array<AdditionalDeviceTypeComponent.Model>;
        /**
         * Whether additional device is automated.
         * @type boolean (`dataFormat` is missing)
         */
        readonly isAutomated: boolean;
        /**
         * Whether the additional device is always visible.
         * @type boolean (`dataFormat` is missing)
         */
        isAlwaysVisible?: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * AdditionalDeviceType DTO
     * Transforms AdditionalDeviceType model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend AdditionalDeviceType model */
        static toModel(obj: AdditionalDeviceType): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend AdditionalDeviceType model */
        static toApi(obj: Model): AdditionalDeviceType {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as AdditionalDeviceType;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
